import { View } from "binder"
import { ImageElement } from "./image-viewModel"
import { stringIsNullOrEmpty } from "src/common/utilities";
import { FormBuilderComponentView } from "src/formBuilder/structure/element";

export class ImageView extends FormBuilderComponentView<ImageElement>{
    GetViewUniqueId(): string {
        return "V-0B7C9E2E-4C50-4C7A-9800-4962251EA4F4"
    }
    loadHtml(): string {
        let element = require('./image.html').default;
        let style = require('./image.less');
        return element;
    }
    constructor() {
       super();
    }
    public set Source(v: string) { this._Source = v; } public get Source(): string { return this._Source;} private _Source: string;
    urlAdder(s){
        if(stringIsNullOrEmpty(s))
            return s;
        else
            return `url(${s})`;
    }
}
